import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { API_REQUEST } from '@/api';
import { WORK_DAY_TYPE, DEFAULT_WORK_DAY_TYPE_CODE, EMPLOYEE_FETCH_CHUNK_SIZE } from '@/config/time-table';
import { numberToTimeString, dateToDateString, getTimeMsFromDateString, lens, filterByUniqueField, splitArray } from '@/common/helpers';
export function canChangeIntegratedAbsenceType(shift, groupPerms) {
  return !!(shift !== null && shift !== void 0 && shift.code) && shift.type === 'A' && (groupPerms === null || groupPerms === void 0 ? void 0 : groupPerms.has_perm_to_change_protected_wdays) === true;
}
export function hexToLuma(colour) {
  var hex = colour.replace(/#/, '');
  var r = parseInt(hex.substr(0, 2), 16);
  var g = parseInt(hex.substr(2, 2), 16);
  var b = parseInt(hex.substr(4, 2), 16);
  return [0.299 * r, 0.587 * g, 0.114 * b].reduce(function (a, b) {
    return a + b;
  }) / 255;
}
export function onSameLine(target, id) {
  var _target$;

  return id.split('_')[1] === ((_target$ = target[0]) === null || _target$ === void 0 ? void 0 : _target$.split('_')[1]);
}
export function toggleSelectionClasses(target, action, type) {
  if (type === 'all') {
    target.classList[action]('td-inner-selection--paste');
    target.classList[action]('td-inner-selection--copy');
  } else if (type === 'paste') {
    target.classList[action]('td-inner-selection--paste');
  } else if (type === 'copy') {
    target.classList[action]('td-inner-selection--copy');
  }

  var hasPasteClass = target.classList.contains('td-inner-selection--paste');
  var hasCopyClass = target.classList.contains('td-inner-selection--copy');

  if (hasPasteClass || hasCopyClass) {
    target.classList.add('td-inner-selection');
  } else {
    target.classList.remove('td-inner-selection');
  }
}
export function showTime(str) {
  return str ? str.split('T')[1].split(':').slice(0, -1).join(':') : '';
}
export function getUser(_x) {
  return _getUser.apply(this, arguments);
}

function _getUser() {
  _getUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _data$, _data$$results;

    var data, user;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return API_REQUEST('getUsers', params);

          case 2:
            data = _context.sent;
            user = data !== null && data !== void 0 && (_data$ = data[1]) !== null && _data$ !== void 0 && (_data$$results = _data$.results) !== null && _data$$results !== void 0 && _data$$results[0] ? data[1].results[0] : data[1][0];
            return _context.abrupt("return", user);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getUser.apply(this, arguments);
}

export function getCreatorName(_x2) {
  return _getCreatorName.apply(this, arguments);
}

function _getCreatorName() {
  _getCreatorName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var workerDays, userId, workers, cellId, creatorId, creatorName, creator, user;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            workerDays = _ref.workerDays, userId = _ref.userId, workers = _ref.workers;
            cellId = Object.keys(workerDays === null || workerDays === void 0 ? void 0 : workerDays[0]).find(function (item) {
              var arr = item.split('_');
              return +arr[arr.length - 1] === userId;
            });
            creatorId = workerDays[0][cellId] && workerDays[0][cellId].created_by_id;

            if (!creatorId) {
              _context2.next = 15;
              break;
            }

            creator = workers.find(function (worker) {
              return worker.id === creatorId;
            });

            if (!(creator && creator.id)) {
              _context2.next = 9;
              break;
            }

            creatorName = creator.fullname;
            _context2.next = 13;
            break;

          case 9:
            _context2.next = 11;
            return getUser({
              id: creatorId
            });

          case 11:
            user = _context2.sent;
            creatorName = "".concat(user.last_name, " ").concat(user.first_name, " ").concat(user.middle_name || '');

          case 13:
            _context2.next = 16;
            break;

          case 15:
            creatorName = '???';

          case 16:
            return _context2.abrupt("return", creatorName);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getCreatorName.apply(this, arguments);
}

export function isCellsHasUnapprovedDay(cells, workerDays) {
  return cells.find(function (cell) {
    var _workerDays$, _workerDays$2;

    var day = (workerDays === null || workerDays === void 0 ? void 0 : (_workerDays$ = workerDays[0]) === null || _workerDays$ === void 0 ? void 0 : _workerDays$[cell]) || (workerDays === null || workerDays === void 0 ? void 0 : (_workerDays$2 = workerDays[1]) === null || _workerDays$2 === void 0 ? void 0 : _workerDays$2[cell]);

    if ((day === null || day === void 0 ? void 0 : day['is_approved']) === false) {
      return true;
    }

    return false;
  });
}
export function isCellsHasApprovedDay(cells, workerDays) {
  return cells.find(function (cell) {
    var _workerDays$3, _workerDays$4;

    var day = (workerDays === null || workerDays === void 0 ? void 0 : (_workerDays$3 = workerDays[0]) === null || _workerDays$3 === void 0 ? void 0 : _workerDays$3[cell]) || (workerDays === null || workerDays === void 0 ? void 0 : (_workerDays$4 = workerDays[1]) === null || _workerDays$4 === void 0 ? void 0 : _workerDays$4[cell]);

    if (day !== null && day !== void 0 && day['is_approved']) {
      return true;
    }

    return false;
  });
}
export function timeFormat(hourName, minuteName, time) {
  if (!time) {
    return '';
  }

  var times = time.split('.');

  if (times.length > 1 && times[1] > 0) {
    times[1] = Math.floor(times[1] / 100 * 60);
  }

  var result = times[0] + hourName;

  if (times[1] > 0) {
    result = "".concat(result, " ").concat(times[1]).concat(minuteName);
  }

  return result;
}
export function getDayType(dayType, dayTypesById) {
  if (!dayType) {
    return '-';
  }

  if (dayType === WORK_DAY_TYPE) {
    return '';
  }

  var day = dayTypesById[dayType];
  return day.is_dayoff ? day.short_name : day.excel_load_code;
}
/**
 * Converts the number of hours to a string format hh:mm
 * @param {string|number} value - quantity of hours
 * @returns {string}
 */

export function showTimeWorkHours(value) {
  if (typeof value === 'number') {
    return numberToTimeString(value);
  }

  return value ? value.split(':').slice(0, -1).join(':') : '';
}
/**
 * Returns the type of working day for the selected shifts
 * @param {object[]} shifts - existed shifts
 * @param {object[]} availableShifts array of available shifts
 * @returns {string}
 */

export function getAvailableShiftType(shifts, availableShifts) {
  var _availableShifts$;

  var rootShiftType = shifts[0].type;
  var rootShift = availableShifts.find(function (el) {
    return el.code === rootShiftType;
  });

  if (!rootShiftType || !rootShift) {
    return DEFAULT_WORK_DAY_TYPE_CODE;
  }

  return rootShift.is_dayoff ? rootShift.allowed_additional_types[0] : (_availableShifts$ = availableShifts[0]) === null || _availableShifts$ === void 0 ? void 0 : _availableShifts$.code;
}
/**
 * Returns the array of shifts indexes to delete after shift type update
 * @param {object[]} shifts - existed shifts
 * @param {object[]} availableShifts array of available shifts
 * @returns {number[]}
 */

export function checkShifts(shifts, availableShifts) {
  var _shifts$;

  if (!shifts || shifts.length < 2) {
    return [];
  }

  var rootShiftType = (_shifts$ = shifts[0]) === null || _shifts$ === void 0 ? void 0 : _shifts$.type;
  var rootShift = availableShifts.find(function (el) {
    return el.code === rootShiftType;
  });

  if (!rootShiftType || !rootShift) {
    return [];
  }

  if (rootShift.is_dayoff) {
    var shiftsIndexToDelete = [];

    for (var i = 1; i < shifts.length; i++) {
      if (!rootShift.allowed_additional_types.includes(shifts[i].type)) {
        shiftsIndexToDelete.push(i);
      }
    }

    return shiftsIndexToDelete;
  }

  return [];
}
/**
 * Adjusts the field dttm_work_end depending on the start and end time of the shift
 * @param {{ dttm_work_start: string?, dttm_work_end: string? }} shiftData
 */

export function getCorrectShiftWorkEndTime(shiftData) {
  var dttm_work_start = shiftData.dttm_work_start,
      dttm_work_end = shiftData.dttm_work_end;
  var startTime = new Date(dttm_work_start);

  if (!dttm_work_end) {
    return '1979-01-01T00:00:00';
  }

  var endTime = new Date(dttm_work_end);

  if (+startTime >= +endTime) {
    endTime = new Date(+endTime + 1000 * 60 * 60 * 24);
    return dateToDateString(endTime);
  }

  if (getTimeMsFromDateString(dttm_work_start) < getTimeMsFromDateString(dttm_work_end)) {
    var startTimeParsed = (dttm_work_start === null || dttm_work_start === void 0 ? void 0 : dttm_work_start.split('T')) || ['1979-01-01', '00:00:00'];
    var endTimeParsed = (dttm_work_end === null || dttm_work_end === void 0 ? void 0 : dttm_work_end.split('T')) || ['1979-01-01', '00:00:00'];
    return "".concat(startTimeParsed[0], "T").concat(endTimeParsed[1]);
  }

  return dttm_work_end;
}
/**
 * Forms parameters for fetching employees
 * @param {object} options
 * @param {string=} options.dateFrom
 * @param {string=} options.dateTo
 * @param {(string|number)[]=} options.employeeIds
 * @param {(string|number)[]=} options.employeeIds
 * @param {string|number=} options.isSkipEmployments
 */

export function formFetchEmployeeParams(_ref2) {
  var dateFrom = _ref2.dateFrom,
      dateTo = _ref2.dateTo,
      employeeIds = _ref2.employeeIds,
      departmentId = _ref2.departmentId,
      isSkipEmployments = _ref2.isSkipEmployments;
  var params = {
    other_deps_employees_with_wd_in_curr_shop: true,
    include_employments: !isSkipEmployments,
    show_constraints: !isSkipEmployments
  };

  if (employeeIds) {
    params.id__in = employeeIds;
  }

  if (departmentId) {
    params.shop_id = departmentId;
  }

  if (dateFrom && dateTo) {
    params.employments__dt_from = dateFrom;
    params.employments__dt_to = dateTo;
  }

  return params;
}
/**
 * Forms Worker object
 * @param {object} options
 * @param {object} options.rawEmployee
 * @param {string|number} options.departmentId
 * @param {object} options.positionsIndexed
 * @param {[string]=} datesInterval
 */

export function formWorker(_ref3, datesInterval) {
  var rawEmployee = _ref3.rawEmployee,
      departmentId = _ref3.departmentId,
      positionsIndexed = _ref3.positionsIndexed;

  var _rawEmployee$user = rawEmployee.user,
      id = _rawEmployee$user.id,
      userData = _objectWithoutProperties(_rawEmployee$user, ["id"]);

  var employments = rawEmployee.employments;

  var worker = _objectSpread(_objectSpread({}, userData), {}, {
    employee_id: rawEmployee.id,
    user_id: id,
    tabel_code: rawEmployee.tabel_code,
    has_shop_employment: !!rawEmployee.has_shop_employment,
    from_another_network: !!rawEmployee.from_another_network,
    visible_after_filter: true,
    is_visible: true,
    fullname: "".concat(userData.last_name || '', " ").concat(userData.first_name || '', " ").concat(userData.middle_name || ''),
    work_types: []
  });

  if (!employments) {
    return _objectSpread(_objectSpread({}, worker), {}, {
      position_name: '',
      employments: [],
      work_types: []
    });
  }

  var positions = [];

  if (departmentId) {
    employments.filter(function (el) {
      return el.is_active && el.shop_id === +departmentId;
    }).forEach(function (el) {
      var _worker$work_types;

      if (!worker.employments) {
        worker.employments = [];
      }

      worker.employments.push(el.id);

      (_worker$work_types = worker.work_types).push.apply(_worker$work_types, _toConsumableArray(el.work_types));
    });
    positions = employments.filter(function (el) {
      return el.is_active && el.shop_id === +departmentId;
    }).map(function (el) {
      return positionsIndexed[el.position_id];
    }).filter(function (el) {
      return el;
    });
    worker.departmentIds = lens(employments.filter(function (el) {
      return el.is_active;
    }), 'shop_id');
  } else {
    employments.filter(function (el) {
      return el.is_active;
    }).forEach(function (el) {
      var _worker$work_types2;

      if (!worker.employments) {
        worker.employments = [];
      }

      worker.employments.push(el.id);

      (_worker$work_types2 = worker.work_types).push.apply(_worker$work_types2, _toConsumableArray(el.work_types));
    });
    positions = employments.filter(function (el) {
      return el.is_active;
    }).map(function (el) {
      return positionsIndexed[el.position_id];
    }).filter(function (el) {
      return el;
    });
  }

  var hasVisibleEmploymentInShop = employments.filter(function (el) {
    return el.shop_id === +departmentId;
  }).some(function (el) {
    return el.is_visible;
  });
  var hasVisibleEmploymentInOtherShop;

  if (datesInterval.length) {
    var dateStart = Date.parse(datesInterval[0]);
    var dateEnd = Date.parse(datesInterval[1]);
    hasVisibleEmploymentInOtherShop = employments.filter(function (empl) {
      if (!empl.dt_fired) return true;
      var dt_fired = Date.parse(empl.dt_fired);
      var dt_hired = Date.parse(empl.dt_hired);
      return dateStart <= dt_fired && dateStart >= dt_hired || dateEnd <= dt_fired && dateEnd >= dt_hired || dt_hired >= dateStart && dt_fired <= dateEnd;
    }).some(function (el) {
      return el.is_visible_other_shops;
    });
  } else {
    // TODO: we need fix this
    hasVisibleEmploymentInOtherShop = employments.filter(function (el) {
      return !el.dt_fired || el.dt_fired && Date.now() < Date.parse(el.dt_fired);
    }) // серьезно, я посмотрю на старые записи, и буду сравнивать работает ли этот чел СЕГОДНЯ, че за дичь?
    .some(function (el) {
      return el.is_visible_other_shops;
    });
  }

  var isVisible = worker.has_shop_employment && hasVisibleEmploymentInShop || !worker.has_shop_employment && hasVisibleEmploymentInOtherShop;
  return _objectSpread(_objectSpread({}, worker), {}, {
    is_visible: isVisible,
    position_name: lens(positions, 'name').join(', '),
    work_types: filterByUniqueField(worker.work_types, 'id')
  });
}
/**
 *
 * @param {{ id__in?: (string|number)[] }} params
 * @param {number} chunkSize
 */

export function splitFetchRequests(params) {
  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPLOYEE_FETCH_CHUNK_SIZE;

  if (!params.id__in) {
    return [params];
  }

  var chunks = splitArray(params.id__in, chunkSize);
  return chunks.map(function (el) {
    return _objectSpread(_objectSpread({}, params), {}, {
      id__in: el
    });
  });
}
/**
 *
 * @param {object} params
 */

export function fetchEmployeesChunked(_x3) {
  return _fetchEmployeesChunked.apply(this, arguments);
}
/**
 * @param {{ allow_to_manually_set_is_vacancy?: boolean }} network
 * @param {{ has_details?: boolean }} dayType
 */

function _fetchEmployeesChunked() {
  _fetchEmployeesChunked = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var chunkedParams, responses, errors, employees;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            chunkedParams = splitFetchRequests(params);
            _context3.next = 3;
            return Promise.all(chunkedParams.map(function (el) {
              return API_REQUEST('getEmployees', el);
            }));

          case 3:
            responses = _context3.sent;
            errors = responses.filter(function (el) {
              return el[0];
            }).map(function (el) {
              return el[0];
            });

            if (!errors.length) {
              _context3.next = 7;
              break;
            }

            throw new Error('Invalid getEmployee server response');

          case 7:
            employees = responses.map(function (el) {
              return el[1];
            }).flat();
            return _context3.abrupt("return", employees);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchEmployeesChunked.apply(this, arguments);
}

export function canSetIsVacancy(network, dayType) {
  return (network === null || network === void 0 ? void 0 : network.allow_to_manually_set_is_vacancy) && (dayType === null || dayType === void 0 ? void 0 : dayType.has_details);
}